import { useCallback, useMemo, useState } from 'react';

const useHeaderTooltip = () => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const showTooltip = useCallback(() => setTooltipVisible(true), []);
  const hideTooltip = useCallback(() => setTooltipVisible(false), []);

  return useMemo(
    () => ({ tooltipVisible, showTooltip, hideTooltip }),
    [tooltipVisible, showTooltip, hideTooltip],
  );
};

export default useHeaderTooltip;
